import { useEffect, useState } from "react"
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { Feedback, TabStatus, FeedbackResponse } from "./BackofficeVideoFeedback.model";

export const pageSize = 10;

export const useBackofficeVideoFeedback = () => {
	const [feedback, setFeedback] = useState<Feedback[]>();
	const [pagination, setPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);

	const { get } = useFetchWrapper();

	const getVideoFeedback = async () => {
		setTabStatus(TabStatus.Loading)
		const response: HttpResponse<FeedbackResponse> = await get(`/review/video-feedback?&page=${pagination.page}&size=${pagination.size}`);
		if (response.parsedBody) {
			const { count, feedbacks } = response.parsedBody;
			setPagination({ ...pagination, total: count });
			setFeedback(feedbacks);
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const onChangeFeedbackPagination = (page: number) => {
		setPagination({...pagination, page })
	}

	useEffect(() => {
		getVideoFeedback()
	}, [pagination.page]);


	return {
		getVideoFeedback,
		onChangeFeedbackPagination,
		state: {
			feedback,
			pagination,
			tabStatus
		}
	}

}